module.exports = __webpack_public_path__ + "static/media/machine-occupied.c040d4af.svg";